module.exports = __webpack_public_path__ + "static/made-in-usa-17a62afc8c3432212a1b5a9e259b8169.svg";